import { Table } from 'react-bootstrap';
import { useAppSelector } from 'redux/store';

const AuditTrail = ({ nodeId }) => {
  const loading = useAppSelector((state) => state?.customerNodeDefinitions.loading.fetchCustomerNodeDefinitionAuditTrail);
  const auditTrailByNodeId = useAppSelector((state) => state?.customerNodeDefinitions.auditTrailByNodeId);
  const nodeKey = Number(nodeId);
  const auditTrail = auditTrailByNodeId?.[nodeKey] || [];

  const Trails = () =>
    !!auditTrail.length &&
    auditTrail.map((audit, index) => {
      const { user_name } = audit;
      let audit_details: any = audit?.audit_details;
      if (typeof audit_details === 'string') {
        try {
          audit_details = JSON.parse(audit_details);
        } catch {
          // not JSON — keep as raw string
        }
      }

      const { action, timestamp, version, differences = [] } = audit_details || {};
      const displayTimestamp = timestamp || audit?.created_at || '';

      // Fix css formatting
      return (
        <tr key={index}>
          <td>{displayTimestamp}</td>
          <td>{action}</td>
          <td>{user_name}</td>
          <td>{version}</td>
          <td>
            {!differences || differences.length === 0 ? (
              <span className="text-muted fst-italic">No changes made.</span>
            ) : (
              differences.map((difference, index) => {
                const { field, old_value, new_value } = difference;

                return (
                  <table key={index} className="mb-2">
                    <tbody>
                      <tr>
                        <td>
                          <span className="fw-bold">Property changed: {field}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span className="fw-bold">Old value:</span>
                          <pre className="ms-2">{JSON.stringify(old_value, null, 2)}</pre>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span className="fw-bold">New value:</span>
                          <pre className="ms-2">{JSON.stringify(new_value, null, 2)}</pre>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                );
              })
            )}
          </td>
        </tr>
      );
    });

  return (
    <Table bordered hover>
      <thead>
        <tr>
          <th>Timestamp</th>
          <th>Type</th>
          <th>User</th>
          <th>Version</th>
          <th>Details</th>
        </tr>
      </thead>
      <tbody>
        {loading && auditTrail.length === 0 ? (
          <tr>
            <td colSpan={5}>Loading audit trail...</td>
          </tr>
        ) : auditTrail.length > 0 ? (
          <Trails />
        ) : (
          <tr>
            <td colSpan={5}>No audit trail available</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default AuditTrail;
